import React from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { FormSelectRow } from "./form-select-row";
import FormModalShell from "../ui/form-modal-shell";
import { CourierActions } from "../ui/courier-fields";

const ManualJobForm = ({
  closeModal,
  loading,
  apiError,
  centers = [],
  createCourierManualJob
}) => (
  <FormModalShell title="Manual Job" apiError={apiError} onClose={closeModal}>
      <Formik
        initialValues={{ center: "", tripDate: "" }}
        validationSchema={Yup.object().shape({
          center: Yup.string().required("Required field")
        })}
        onSubmit={values => {
          const data = { center: Number(values.center) };
          if (values.tripDate) data.tripDate = values.tripDate;
          createCourierManualJob(data);
        }}
      >
        {formik => (
          <Form>
            <FormSelectRow
              label="Center"
              name="center"
              value={formik.values.center}
              onChange={e => formik.setFieldValue("center", e.target.value)}
              error={formik.touched.center && formik.errors.center}
              required
              options={centers.map(c => ({ value: c.id, label: c.name }))}
            />
            <div className="form-row">
              <label>Trip Date (optional)</label>
              <input
                type="date"
                name="tripDate"
                value={formik.values.tripDate}
                onChange={e =>
                  formik.setFieldValue("tripDate", e.target.value)
                }
              />
            </div>
            <CourierActions
              loading={loading}
              submitLabel="Create Job"
              onCancel={closeModal}
            />
          </Form>
        )}
      </Formik>
  </FormModalShell>
);

export default ManualJobForm;
